import React from 'react'
import { InputHLPure } from '../../../../pures';

function InputPureWrapper(fieldRenderProps) {
    const { id, label, value, onChange, visited, validationMessage } = fieldRenderProps;

    return (
        <InputHLPure
            id={id}
            labelInput={label}
            valueInput={value}
            handleChangeInput={onChange}
            errorInput={visited && validationMessage}
            errorInputText={validationMessage}
            {...fieldRenderProps}
        />
    );
};

export default InputPureWrapper